import { render, staticRenderFns } from "./EmptyBlock.vue?vue&type=template&id=5f4b4f30"
import script from "./EmptyBlock.vue?vue&type=script&lang=ts"
export * from "./EmptyBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports